import { AutomationExecutionNodeStatusEnum } from '@repo/utils';
import { type Node } from '@xyflow/react';
import { z } from 'zod';

import { ActionTypes, ConditionTypes, Triggers } from '../automationConfig';

// Define Zod schemas for the types
export const CommonNodeDataSchema = z.object({
  nodeSubType: z.nativeEnum(Triggers).or(z.nativeEnum(ConditionTypes)).or(z.nativeEnum(ActionTypes)),
  executionOrder: z.number().optional(),
  additionalOptions: z.record(z.unknown()).optional(),
  menuOpen: z.boolean().optional(),
  // Client generated id after node is created
  oldNodeId: z.string().optional(),
  successExecutionCounts: z.number().optional(),
  executionStatus: z.nativeEnum(AutomationExecutionNodeStatusEnum).optional(),
});

export type CommonNodeData = z.infer<typeof CommonNodeDataSchema>;
export type EmptyNodeType = Node<CommonNodeData>;
